import escapeRegExp from '../escapeRegExp';

export default function byName(obj: any, filter: any) {
  if (!filter) {
    return true;
  }

  return new RegExp(escapeRegExp(filter), 'gi').test(obj.name);
}
